import format from 'date-fns/format'
import _some from 'lodash/some'
import { string as YupString } from 'yup'

const validPhoneNumber = phoneNumber => {
  return phoneNumber && !isNaN(Number(phoneNumber)) && /^\+?\d{8,}/.test(phoneNumber);
}

const validPassword = password => {
  const passwordValue = password || ''
  return /^(?=.*[a-z])(?=.*[0-9]).{8,}$/i.test(passwordValue.toString());
}

/**
 * can begin with a letter or digit or . or _ or - or % or +
 * and should contain "@" and followed by one or more characters
 * and followed by "." and one or more charaters
 */
const validEmail = email =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )

const getTimeslotDataFromSlots = (
  timeslots,
  selectedTimeslot,
  selectedSlotId
) => {
  if (timeslots[selectedTimeslot]) {
    return timeslots[selectedTimeslot].find(
      timeslot => timeslot.id === selectedSlotId
    )
  }
  return null
}

const findTheEarliestAvailableDate = timeslots => {
  if (!timeslots) {
    return null
  }

  const dates = Object.keys(timeslots)
  for (let i = 0; i < dates.length; i++) {
    const date = dates[i]
    const isFoundAvailableSlot = _some(timeslots[date], 'available')
    if (isFoundAvailableSlot) {
      return date
    }
  }
  return null
}

const getSelectedDate = (selectedTimeSlot, timeslots) => {
  if (selectedTimeSlot && selectedTimeSlot.startTime) {
    return format(selectedTimeSlot.startTime, 'YYYY-MM-DD')
  }

  if (!timeslots) {
    return null
  }

  const date = findTheEarliestAvailableDate(timeslots)
  return date ? date : Object.keys(timeslots)[0]
}

// account management
const sentenceCase = text => `${text[0].toUpperCase()}${text.slice(1)}`

const requiredErrorMessage = fieldName => `Please enter ${fieldName}.`
const maxLengthMessage = (fieldName, max) =>
  `${sentenceCase(fieldName)} must be within ${max} characters.`
const minLengthMessage = (fieldName, min) =>
  `${sentenceCase(fieldName)} must have at least ${min} characters.`

const requiredValidation = (fieldName, customErrorMessage = '') =>
  YupString()
    .trim()
    .required(customErrorMessage || requiredErrorMessage(fieldName))

const lengthValidation = (
  fieldName,
  maxLength,
  minLength = 0,
  required = false
) => {
  const basicValidation = required
    ? requiredValidation(fieldName)
    : YupString().trim()

  const maxValidation = basicValidation.max(
    maxLength,
    maxLengthMessage(fieldName, maxLength)
  )

  if (minLength > 0) {
    return maxValidation.min(minLength, minLengthMessage(fieldName, minLength))
  }

  return maxValidation
}

const floorUnitValidation = ({ fieldName }) =>
  YupString().when('hasFloorUnit', (hasFloorUnit, schema) => {
    return hasFloorUnit === '1'
      ? schema.trim().required(requiredErrorMessage(fieldName))
      : schema
  })

const nameValidation = ({ invalidNameMsg, maxLength, fieldName }) => {
  const field = fieldName || 'your name'
  return lengthValidation(field, maxLength, 0, true).matches(
    /* eslint-disable */
    new RegExp(/^[A-z\xc0-\xff]+(?:(?:[A-z\xc0-\xff\d ',\.\-\/])?)+$/i),
    /* eslint-disable */
    invalidNameMsg
  );
}

const landlineValidation = ({
  invalidLandlineMsg,
  fieldName,
  emptyLandlineMsg,
}) => {
  const field = fieldName || 'your phone number'
  return requiredValidation(field, emptyLandlineMsg).matches(
    new RegExp(/^[689]\d{7}$/i),
    invalidLandlineMsg
  );
}

const addressValidation = {
  requiredValidation,
  floorUnitValidation,
  nameValidation,
  landlineValidation,
}

const businessProfileValidation = {
  landlineValidation,
  lengthValidation,
  requiredValidation,
}

export {
  validPhoneNumber,
  validEmail,
  validPassword,
  getTimeslotDataFromSlots,
  findTheEarliestAvailableDate,
  getSelectedDate,
  requiredValidation,
  lengthValidation,
  floorUnitValidation,
  nameValidation,
  landlineValidation,
  addressValidation,
  businessProfileValidation,
}
